import {
  Collapse,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import { Card, Box, ListItem, CardHeader, IconButton } from 'components'
import { Charge as ChargeResp, useLoadOrderCharges } from 'modules/orders/hooks'
import { Order } from 'modules/orders/types'
import { get } from 'lodash'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { Fragment, useState } from 'react'
import { formatDate, phoneMask } from 'utils'

const firstColumn: any = [
  {
    label: 'Motorista',
    key: 'driver.name'
  },
  {
    label: 'Código',
    key: 'driver.id'
  },
  {
    label: 'Telefone',
    key: 'driver.phone',
    transform: (value: string) => phoneMask(value)
  },
  {
    label: 'SaÍda',
    key: 'outputForecast',
    transform: (value: string) => formatDate(value)
  }
]

const secondColumn = [
  {
    label: 'Transportadora',
    key: 'carrier.name'
  },
  {
    label: 'Código',
    key: 'carrier.id'
  },
  {
    label: 'Placa',
    key: 'carrier.plate'
  },
  {
    label: 'Retorno',
    key: 'returnForecast',
    transform: (value: string) => formatDate(value)
  }
]

function Row(props: { row: ChargeResp }) {
  const { row } = props
  const [open, setOpen] = useState(false)

  return (
    <Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell component="th" scope="row">
          {row.chargeId}
        </TableCell>
        <TableCell align="right">{row.status}</TableCell>
        <TableCell align="right">{row.sequence}</TableCell>
        <TableCell align="right">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Grid container spacing={3} style={{ padding: 24 }}>
                <Grid item xs={12} sm={6}>
                  {firstColumn?.map((item: any) => (
                    <ListItem
                      key={item.key}
                      label={item.label}
                      value={get(row, item.key)}
                      transform={item?.transform}
                    />
                  ))}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {secondColumn?.map((item: any) => (
                    <ListItem
                      key={item.key}
                      label={item.label}
                      value={get(row, item.key)}
                      transform={item?.transform}
                    />
                  ))}
                </Grid>
                <Grid item xs={12}>
                  <ListItem label="observação" value={row.observation} />
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  )
}

export const Charge = ({ order }: { order: Order }) => {
  const { data } = useLoadOrderCharges({
    orderId: order?.orderId
  })

  return (
    <div>
      <Card
        sx={{
          visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
          padding: { xs: 0, sm: 0, md: 0 },
          maxWidth: 900
        }}
      >
        <Box
          sx={{ visibility: { xs: 'visible', sm: 'visible', md: 'visible' } }}
        >
          <Box
            sx={{
              padding: {
                xs: 0,
                sm: '0 24px 0 0',
                md: '0px 24px 0 0px'
              },
              borderBottom: { xs: 'none', sm: '1px solid #E0E0E0' }
            }}
          >
            <CardHeader title="Cargas" />
          </Box>
          <TableContainer component={Paper}>
            <Table aria-label="collapsible table" size="small">
              <TableHead>
                <TableRow hover={false}>
                  <TableCell>N° Carga</TableCell>
                  <TableCell align="right">Situação</TableCell>
                  <TableCell align="right">Sequência</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {!data?.data.length && (
                  <Grid container spacing={3} style={{ padding: 24 }}>
                    <Grid item xs={12}>
                      <Typography>Nenhuma carga encontrada!</Typography>
                    </Grid>
                  </Grid>
                )}

                {data?.data?.map((row) => (
                  <Row key={row.chargeId} row={row} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Card>
    </div>
  )
}
